import useThemeColor from '@/hooks/useThemeColor';
import {Act} from '@/types/generated-types';
import React, {useEffect, useState} from 'react';
import {StyleSheet, Text} from 'react-native';
import formatDistance from '@/helpers/formatDistance';

type Props = {act: Act};

function ActPublishedAt({act}: Props) {
  const styles = StyleSheet.create({
    postPublishedDate: {
      marginHorizontal: 8,
      color: useThemeColor('text'),
    },
  });

  const [timeAgo, setTimeAgo] = useState(formatDistance(act.publishedAt));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeAgo(formatDistance(act.publishedAt));
    }, 3000);

    // clearing interval
    return () => clearInterval(timer);
  });

  return (
    <Text numberOfLines={1} style={styles.postPublishedDate}>
      {act.publishedAt && timeAgo}
    </Text>
  );
}

export default ActPublishedAt;
